// extracted by mini-css-extract-plugin
module.exports = {"issue":"AddedIssues_issue__1HCkO","headerMazda":"AddedIssues_headerMazda__2uY1t","issueText":"AddedIssues_issueText__17NEi","icon":"AddedIssues_icon__2cql2"};